export default __webpack_public_path__ + "static/media/alpha-eth-uni-closed-logo.ef829ef8.svg";